import {
  BarChart3,
  Bell,
  History,
  FolderTree,
  Image as ImageIcon,
  Info,
  LayoutDashboard,
  MapPin,
  Settings2,
  UserRound,
} from "lucide-react";

/** Nguồn dữ liệu duy nhất cho sidebar + tiêu đề/breadcrumb trên header. */
export const ADMIN_NAV = [
  {
    key: "overview",
    title: "Tổng quan",
    items: [
      { label: "Dashboard", to: "/admin/dashboard", icon: LayoutDashboard },
      { label: "Truy cập & lượt xem", to: "/admin/overview", icon: BarChart3 },
      { label: "Thông báo", to: "/admin/notifications", icon: Bell, badge: "unread" },
    ],
  },
  {
    key: "content",
    title: "Nội dung",
    items: [
      { label: "Địa điểm", to: "/admin/locations", icon: MapPin },
      { label: "Danh mục", to: "/admin/categories", icon: FolderTree },
      { label: "Thư viện media", to: "/admin/media", icon: ImageIcon },
    ],
  },
  {
    key: "customers",
    title: "Khách hàng",
    items: [{ label: "Người dùng", to: "/admin/users", icon: UserRound, perm: "users:manage" }],
  },
  {
    key: "system",
    title: "Hệ thống",
    items: [
      { label: "Cài đặt chung", to: "/admin/settings/global", icon: Settings2 },
      { label: "Giới thiệu", to: "/admin/settings/about", icon: Info },
      { label: "Nhật ký thao tác", to: "/admin/audit", icon: History, perm: "audit:read" },
    ],
  },
];

/** Tìm mục menu khớp với pathname hiện tại (khớp dài nhất trước). */
export function getPageMeta(pathname) {
  const flat = ADMIN_NAV.flatMap((g) => g.items.map((item) => ({ ...item, section: g.title })));
  const match = flat
    .filter((it) => pathname === it.to || pathname.startsWith(`${it.to}/`))
    .sort((a, b) => b.to.length - a.to.length)[0];
  if (match) return match;
  if (pathname.startsWith("/admin/settings")) {
    return { label: "Cài đặt", section: "Hệ thống", to: "/admin/settings" };
  }
  return { label: "Admin", section: "", to: "/admin" };
}
